const apiBase = locationLike => locationLike?.origin || ''

async function post(path, body, { fetchImpl = globalThis.fetch, locationLike = globalThis.location } = {}) {
  const response = await fetchImpl(`${apiBase(locationLike)}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  })
  const data = await response.json().catch(() => ({ ok: false }))
  if (!response.ok || data.ok !== true) throw new Error('Guest session request rejected')
  return data
}

export async function exportGuestRecovery(options) {
  const data = await post('/api/auth/recovery/export', {}, options)
  return data.recoveryCode
}

export async function recoverGuestSession(recoveryCode, options) {
  return post('/api/auth/recovery', { recoveryCode: String(recoveryCode || '').trim() }, options)
}
